import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core'
import { Subject }    from 'rxjs';

@Injectable()
export class SharedService {
  private caseNumber = new Subject<string>();  
  caseNumber$ = this.caseNumber.asObservable();
  @Output() loader: EventEmitter<any> = new EventEmitter();
  @Output() dataTable: EventEmitter<any> = new EventEmitter();
  @Output() value: EventEmitter<any> = new EventEmitter();
  @Output() exportRequest: EventEmitter<any> = new EventEmitter();
  constructor() {
    
  }

  showloader(data) {
    this.loader.emit(data);
  }

  getEmittedValue() {
    return this.loader;
  }

  getTabValue(data) {
    this.value.emit(data);
  }

  publishProfilePicture(data:any) {
    this.caseNumber.next(data);
  }
  getExportRequest(data){
    this.exportRequest.next(data);
  }
}